import { render } from "./IndividualOjtAssessmentReport.vue?vue&type=template&id=34aa6230&scoped=true"
import script from "./IndividualOjtAssessmentReport.vue?vue&type=script&lang=js"
export * from "./IndividualOjtAssessmentReport.vue?vue&type=script&lang=js"

import "./IndividualOjtAssessmentReport.vue?vue&type=style&index=0&id=34aa6230&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aa6230"]])

export default __exports__